import { getTasks } from '../../../../Requests/tasks/tasks';

export interface FlyerTask {
  task_id: string;
  title: string;
  description: string;
  btn_text: string;
  image_url: string;
  link: string;
  icon: string;
  status: string;
  task_type: string;
  provider: 'FLYER' | 'SUBGRAM';
  details: {
    type: string;
    photo: string;
  };
  id: string | number;
}

export interface FlyerStatusTask {
  details: {
    task_id: string;
  };
  task_id: string;
  user_metadata: {
    status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  };
  id: string | number;
}

export type TaskProvider =
  | 'PARTNERS'
  | 'DAILY'
  | 'SPONSORS'
  | 'BARZHA'
  | 'TAPPADS'
  | 'DREAMCOIN_CLICK'
  | 'DREAMCOIN_SUBSCRIBE'
  | 'BARZHA_CLICK'
  | 'FLYER'
  | 'SUBGRAM'
  | 'TADDY';

export interface Task {
  id: string | number;
  title: string;
  image?: string;
  centerIcon?: string;
  icon: string;
  type: string;
  group?: 'individual' | 'combined';
  description?: string;
  rewards?: {
    dc?: number;
    tickets?: number;
    [key: string]: number | undefined;
  };
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'WAITING' | 'DONE' | 'CLAIMED';
  buttonText: string;
  link?: string;
  is_subscribed?: boolean;
  progress?: {
    current: number;
    total: number;
  };
  provider: TaskProvider;
  responseType?: string;
  completed_elsewhere?: boolean;
  task_instructions?: string[];
  modalButtonText?: string;
  verifyButton?: string;
  // meta?: {
  //   adId?: number;
  //   ads?: any[];
  // };
  // onClick?: () => Promise<boolean>;
}

export class FlyerAdapter {
  static async getFeed(): Promise<FlyerTask[]> {
    try {
      const res = await getTasks('partner', 'flyer');
      console.log('📦 Получены задания от Flyer:', res);
      let tasks = (Array.isArray(res) ? res : []) as FlyerTask[];
      tasks = tasks.filter((task) => task.details.type !== 'CPC');
      console.log('tasks --------- ', tasks);
      const sortStatus = [
        'DONE',
        'NOT_STARTED',
        'IN_PROGRESS',
        'WAITING',
        'CLAIMED',
      ];

      return tasks
        .map((task: FlyerTask) => ({
          // Явно указываем тип task
          ...task,
          provider: 'FLYER' as const,
        }))
        .filter((t) => t.task_type !== 'give boost')
        .sort((a, b) => {
          return sortStatus.indexOf(a.status) - sortStatus.indexOf(b.status);
        });
    } catch (error) {
      console.error('❌ Ошибка получения заданий от Flyer:', error);
      return [];
    }
  }

  static async getStatusTasks(): Promise<FlyerStatusTask[]> {
    try {
      const res = await getTasks('partner', 'flyer');

      const statusTasks = (Array.isArray(res) ? res : []) as FlyerStatusTask[];
      const sortStatus = [
        'DONE',
        'NOT_STARTED',
        'IN_PROGRESS',
        'WAITING',
        'CLAIMED',
      ];

      console.log('📋 Статусы заданий Flyer (внешний запрос):', statusTasks);
      return statusTasks.sort((a, b) => {
        return (
          sortStatus.indexOf(a.user_metadata.status) -
          sortStatus.indexOf(b.user_metadata.status)
        );
      });
    } catch (error) {
      console.error(
        '❌ Ошибка получения статусов заданий Flyer (внешний запрос):',
        error,
      );
      return [];
    }
  }

  static async adaptTasks(
    flyerTasks: FlyerTask[],
    statusTasks?: FlyerStatusTask[],
  ): Promise<Task[]> {
    console.log('🔄 FlyerAdapter.adaptTasks - start', { flyerTasks });
    console.log(
      '🔄 - - - - - - FlyerAdapter.adaptTasks - statusTasks:',
      this.getStatusTasks(),
    );

    try {
      const currentStatusTasks = statusTasks ?? (await this.getStatusTasks());
      console.log('📋 Текущие статусы заданий Flyer:', currentStatusTasks);

      const adaptedTasks = flyerTasks.reduce<Task[]>((acc, task) => {
        const statusTask = currentStatusTasks.find((st) => st.id === task.id);
        const status = statusTask?.user_metadata.status || 'NOT_STARTED';
        console.log('status --------- ', status, task.title);
        // если image_url = null, используем дефолтное изображение
        const image_url = task.details.photo ? task.details.photo : '';

        console.log('image_url --------- ', image_url);

        const buttonText = status === 'WAITING' ? 'Проверка...' : '';

        acc.push({
          id: task.id,
          title: task.title,
          description: task.description,
          icon: image_url,
          type: 'sponsors',
          rewards: {
            beastcoins: 1,
          },
          status,
          buttonText,
          link: task.link,
          progress: {
            current: 0,
            total: 1,
          },
          provider: 'FLYER' as TaskProvider,
        });

        return acc;
      }, []);

      return adaptedTasks;
    } catch (error) {
      console.error('❌ Ошибка при адаптации заданий Flyer:', error);
      return [];
    }
  }
}
